import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// // redirect to login page whenever token is no longer valid
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       console.log('validated');
//       store.dispatch('users/setUnauthenticated');
//       this.$router.push('/login');
//     }
//     return Promise.reject(error);
//   },
// );

export default {
  namespaced: true,
  state: {
    teams: [],
    departments: [],
    management: [],
  },
  mutations: {
    updateTeams(state, newTeams) {
      state.teams = newTeams;
    },
    updateDepartments(state, newDepartments) {
      state.departments = newDepartments;
    },
    updateManagement(state, newManagement) {
      state.management = newManagement;
    },
  },
  actions: {
    getTeams(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/teams/',
          method: 'get',
        }).then((response) => {
          context.commit('updateTeams', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateTeams', []);
          reject(error.response.data);
        });
      });
    },
    saveTeam(context, teamInfo) {
      const teamId = teamInfo.id;
      const reqMethod = teamId === 0 ? 'post' : 'put';
      const reqUrl = teamId === 0
        ? '/api/employee/team-create/'
        : `/api/employee/team-edit/${teamId}/`;
      return new Promise((resolve, reject) => {
        axios({
          url: reqUrl,
          method: reqMethod,
          data: teamInfo,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveDepartment(context, departmentInfo) {
      const departmentId = departmentInfo.id;
      const reqMethod = departmentId === 0 ? 'post' : 'put';
      const reqUrl = departmentId === 0
        ? '/api/employee/departments-create/'
        : `/api/employee/departments-edit/${departmentId}/`;
      return new Promise((resolve, reject) => {
        axios({
          url: reqUrl,
          method: reqMethod,
          data: departmentInfo,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDepartments(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/departments/',
          method: 'get',
        }).then((response) => {
          context.commit('updateDepartments', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateDepartments', []);
          reject(error.response.data);
        });
      });
    },
    getManagement(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/employee/management/',
          method: 'get',
        }).then((response) => {
          context.commit('updateManagement', response.data);
          resolve(response.data);
        }).catch((error) => {
          context.commit('updateManagement', []);
          reject(error.response.data);
        });
      });
    },
  },
  getters: {
    getTeams(state) {
      return state.teams;
    },
    getDepartments(state) {
      return state.departments;
    },
    getManagement(state) {
      return state.management;
    },
  },
};
